class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[data-announcement-slider]');
    if (!this.slider) return;

    this.slides = this.querySelectorAll('[data-announcement-slide]');
    if (this.slides.length < 2) return;

    this.intervalTime = parseInt(this.dataset.interval) * 1000 || 5000;
    this.autoplayEnabled = this.dataset.autoplay === 'true';

    // Infinite scroll setup
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.isTransitioning = false;

    // Clone first slide for seamless loop
    const firstSlideClone = this.slides[0].cloneNode(true);
    firstSlideClone.setAttribute('aria-hidden', true);
    this.slider.appendChild(firstSlideClone);

    if (this.autoplayEnabled) {
      this.initAutoplay();
    }

    // Bind transition end
    this.slider.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
  }

  initAutoplay() {
    this.startTimer();

    this.addEventListener('mouseenter', () => this.stopTimer());
    this.addEventListener('mouseleave', () => this.startTimer());
    this.addEventListener('focusin', () => this.stopTimer());
    this.addEventListener('focusout', () => this.startTimer());
  }

  startTimer() {
    this.stopTimer();
    this.timer = setInterval(() => this.nextSlide(), this.intervalTime);
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  nextSlide() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.currentSlide++;
    this.updateSlider();
  }

  updateSlider() {
    this.slider.style.transition = 'transform 0.5s ease-in-out';
    const translateX = -(this.currentSlide * 100);
    this.slider.style.transform = `translateX(${translateX}%)`;
  }

  handleTransitionEnd() {
    this.isTransitioning = false;

    // If we reached the clone (last index), reset to 0 instantly
    if (this.currentSlide >= this.totalSlides) {
      this.slider.style.transition = 'none';
      this.currentSlide = 0;
      const translateX = 0;
      this.slider.style.transform = `translateX(${translateX}%)`;

      // Force repaint to ensure the removal of transition takes effect before next frame potential updates
      // void this.slider.offsetWidth; 
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);
